<template>
  <div
    v-if="showModalLoadingSpinner"
    class="modal-dialog modal-dialog-centered modal-xl"
    role="document"
  >
    <div
      class="modal-content"
      style="height: 100%; width: 100%; overflow-y: auto; text-align: left !important"
    >
      <div class="modal-body p-0">
        <div
          class="card card-plain"
          style="height: 100%"
        >
          <div
            class="card-body justify-content-left d-flex flex-column align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="spinner-border"
              style="width: 100px; height: 100px"
              role="status"
            ></div>
            <p class="mt-3">Loading...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else-if="gunDataset.length > 0"
    class="modal-dialog modal-dialog-centered modal-xl"
    role="document"
  >
    <div
      class="modal-content"
      style="text-align: left !important"
    >
      <div class="modal-body p-0">
        <div class="card card-plain">
          <div class="card-body justify-content-left">
            <button
              ref="dismissButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="
                color: black;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 99999 !important;
                margin: 10px;
                padding: 5px;
              "
            >
              <font-awesome-icon :icon="['fas', 'xmark']" />
            </button>
            <div class="d-flex align-items-center justify-content-between mb-2 mt-2 position-relative">
              <h3 class="text-start">
                Detailed View of Guns
                <span v-if="hopperName">for {{ hopperName }}</span>
              </h3>
              <div
                v-if="createdAtTimestamp"
                class="d-flex align-items-center justify-content-center me-4"
              >
                <span class="text-sm text-muted me-2 mb-2"> Created: </span>
                <h6 class="text-sm">{{ createdAtTimestamp }}</h6>
              </div>
            </div>
            <SteelCaseGunsEqualizationChart
              :datasets="gunDataset"
              :recipes="gunRecipes"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="modal-dialog modal-dialog-centered modal-sm"
    role="document"
  >
    <div
      class="modal-content"
      style="text-align: left !important"
    >
      <div class="modal-body p-0">
        <div class="card card-plain">
          <div class="card-body justify-content-left">
            <button
              ref="dismissButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label=""
              style="
                color: black;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 99999 !important;
                margin: 10px;
                padding: 5px;
              "
            >
              <font-awesome-icon :icon="['fas', 'xmark']" />
            </button>
            <div
              class="swal2-icon swal2-error swal2-icon-show"
              style="display: flex"
            >
              <span class="swal2-x-mark">
                <span class="swal2-x-mark-line-left"></span>
                <span class="swal2-x-mark-line-right"></span>
              </span>
            </div>
            <h3 class="text-center">Error</h3>
            <p class="text-center">Failed to fetch detailed data for these guns.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SteelCaseGunsEqualizationChart from "./SteelCaseGunsEqualizationChart.vue";

library.add(faXmark);

export default {
  name: "GunMultipleModal",
  components: {
    SteelCaseGunsEqualizationChart,
    FontAwesomeIcon,
  },
  props: {
    gunDataset: {
      type: Array,
      default: () => [],
    },
    gunRecipes: {
      type: Array,
      default: () => [],
    },
    hopperName: {
      type: String,
      optional: true,
      default: null,
    },
    createdAtTimestamp: {
      type: String,
      optional: true,
      default: null,
    },
    showModalLoadingSpinner: {
      type: Boolean,
      required: true,
    },
  },
  emits: [],
  computed: {},
  methods: {
    closeModal() {
      const dismissButton = this.$refs.dismissButton;
      if (dismissButton) {
        dismissButton.click();
      }
    },
  },
};
</script>
